import React from 'react';

import { useSelector } from 'react-redux';

import OrderStatusLabel from '../../../../components/order-status-label';
import { useFulfillmentPlanIdContext } from '../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import Global from '../../../../store/global-selectors';

import style from './shipment-attributes.module.less';

export const ShipmentAttributes = () => {
  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const fulfillmentPlanStatus =
    useSelector((state) =>
      Global.selectEntitiesFulfillmentPlanOrderGridStatus(state, {
        fulfillmentPlanId,
      }),
    ) ?? '';

  return <OrderStatusLabel status={fulfillmentPlanStatus.toLowerCase()} wrapperClassname={style['status-label-wrapper']} />;
};
